var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ViewLayoutStatus } from './view-layout-status.enum';
var LayoutDefault = /** @class */ (function () {
    function LayoutDefault(status, enable) {
        if (status === void 0) { status = ViewLayoutStatus.Hide; }
        if (enable === void 0) { enable = true; }
        this.status = status;
        this.enable = enable;
    }
    return LayoutDefault;
}());
export { LayoutDefault };
var LogoLayout = /** @class */ (function (_super) {
    __extends(LogoLayout, _super);
    function LogoLayout(isHyperLink) {
        if (isHyperLink === void 0) { isHyperLink = true; }
        var _this = _super.call(this) || this;
        _this.isHyperLink = isHyperLink;
        return _this;
    }
    return LogoLayout;
}(LayoutDefault));
export { LogoLayout };
var DrawerLayout = /** @class */ (function (_super) {
    __extends(DrawerLayout, _super);
    function DrawerLayout(isExpandedInitially) {
        if (isExpandedInitially === void 0) { isExpandedInitially = false; }
        var _this = _super.call(this) || this;
        _this.isExpandedInitially = isExpandedInitially;
        return _this;
    }
    return DrawerLayout;
}(LayoutDefault));
export { DrawerLayout };
var ViewLayoutModel = /** @class */ (function () {
    function ViewLayoutModel() {
    }
    return ViewLayoutModel;
}());
export { ViewLayoutModel };
